module.exports = __webpack_public_path__ + "media/customizations/mywilloway/chat-bubble-7fca39f80405e3f6139df725041bad07.png";